var _style, _g, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _g3, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g4, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarbonChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 523.6 337.4",
    style: {
      enableBackground: "new 0 0 523.6 337.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#46F8E2;}\n\t.st2{clip-path:url(#SVGID_00000104706441897527927370000011546271811763683731_);}\n\t.st3{fill:none;stroke:#E3E9EF;stroke-linecap:square;stroke-miterlimit:10;}\n\t.st4{opacity:0.2;fill:url(#Path_value_00000116221369433144776360000011022314650858934402_);enable-background:new    ;}\n\t.st5{fill:none;stroke:#51F7E2;stroke-width:5;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}\n\t.st7{fill:none;}\n\t.st8{fill:#677489;}\n\t.st9{opacity:0.2;fill:url(#Path_value_00000002371092874585483930000008414075338826719899_);enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.2,21.3c0.8,1.1,1.2,2.4,1.2,3.8c0,1.3-0.4,2.6-1.1,3.7c-0.7,1.1-1.7,2-3,2.7c-1.3,0.7-2.6,1-4.1,1 c-1.5,0-2.9-0.3-4.1-1c-1.2-0.7-2.2-1.6-2.9-2.7c-0.7-1.1-1.1-2.4-1.1-3.7c0-1.5,0.4-2.7,1.2-3.8c0.8-1.1,1.8-1.9,3-2.5 c-1-0.5-1.9-1.3-2.5-2.4c-0.7-1.1-1-2.2-1-3.5c0-1.3,0.3-2.6,1-3.7c0.7-1.1,1.6-2,2.7-2.6c1.2-0.6,2.4-0.9,3.8-0.9 c1.4,0,2.6,0.3,3.8,0.9c1.2,0.6,2.1,1.5,2.7,2.6c0.7,1.1,1,2.3,1,3.7c0,1.3-0.3,2.5-1,3.5c-0.7,1-1.6,1.8-2.6,2.4 C53.4,19.3,54.4,20.2,55.2,21.3z M52.5,28.9c1.1-1,1.6-2.2,1.6-3.7c0-1-0.3-1.9-0.8-2.7c-0.5-0.8-1.2-1.5-2.1-1.9 c-0.9-0.5-1.9-0.7-2.9-0.7c-1,0-2,0.2-2.9,0.7c-0.9,0.5-1.6,1.1-2.1,1.9c-0.5,0.8-0.8,1.7-0.8,2.7c0,1.5,0.5,2.8,1.6,3.7 c1.1,1,2.5,1.5,4.2,1.5S51.4,29.9,52.5,28.9z M44.5,9.2c-1,0.9-1.4,2.2-1.4,3.6c0,1,0.2,1.9,0.7,2.6c0.5,0.8,1.1,1.4,1.9,1.8 c0.8,0.4,1.7,0.6,2.6,0.6c0.9,0,1.8-0.2,2.6-0.6c0.8-0.4,1.4-1,1.9-1.8c0.5-0.8,0.7-1.7,0.7-2.6c0-1.5-0.5-2.7-1.4-3.6 c-1-0.9-2.2-1.4-3.7-1.4C46.7,7.8,45.5,8.3,44.5,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.2,6c0.2,0.2,0.3,0.5,0.3,0.8c0,0.1,0,0.3-0.1,0.5L67.9,31.6c-0.1,0.2-0.3,0.4-0.5,0.6 c-0.2,0.1-0.4,0.2-0.6,0.2c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.4-0.5-0.4-0.8c0-0.2,0-0.4,0.1-0.6l9.8-22.9H63.4 c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.5-0.3,0.8-0.3h14C77.7,5.6,78,5.7,78.2,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86,34.3c-0.4,0.7-0.8,1.3-1.4,1.8c-0.6,0.5-1.1,0.7-1.6,0.7c-0.3,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.3-0.3-0.3-0.6 c0-0.3,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.6-0.3s0.5-0.2,0.6-0.2c0.4-0.2,0.6-0.4,0.8-0.8c0.2-0.3,0.3-0.7,0.3-1.1 c0-0.3-0.1-0.5-0.2-0.7c-0.2-0.2-0.4-0.3-0.6-0.3c-0.4,0-0.7,0.1-1,0.3c-0.3-0.3-0.5-0.6-0.5-0.9c0-0.5,0.2-0.9,0.7-1.2 s0.9-0.5,1.5-0.5c0.7,0,1.2,0.2,1.6,0.6c0.4,0.4,0.6,1,0.6,1.7C86.6,32.8,86.4,33.6,86,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.9,6c0.2,0.2,0.3,0.5,0.3,0.8v24.3c0,0.3-0.1,0.6-0.4,0.8c-0.2,0.2-0.5,0.3-0.9,0.3c-0.3,0-0.6-0.1-0.8-0.3 c-0.2-0.2-0.3-0.5-0.3-0.8V8.9L91,11.7c-0.2,0.1-0.4,0.2-0.5,0.2c-0.3,0-0.6-0.1-0.9-0.4c-0.2-0.3-0.4-0.5-0.4-0.8 c0-0.2,0.1-0.4,0.2-0.5c0.1-0.2,0.3-0.3,0.4-0.4l6.4-3.9c0.3-0.2,0.6-0.2,0.9-0.2C97.4,5.7,97.7,5.8,97.9,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.3,16.4c1.2,0.7,2.2,1.6,3,2.9c0.7,1.3,1.1,2.8,1.1,4.5s-0.4,3.3-1.2,4.6c-0.8,1.3-1.9,2.4-3.4,3.1 c-1.4,0.7-3,1.1-4.7,1.1c-1.1,0-2.1-0.2-3.2-0.5c-1-0.4-1.9-0.9-2.6-1.6c-0.4-0.3-0.5-0.6-0.5-0.9c0-0.3,0.1-0.6,0.3-0.9 c0.2-0.3,0.5-0.4,0.8-0.4c0.3,0,0.6,0.1,0.9,0.4c1.1,1.1,2.5,1.7,4.4,1.7c1.2,0,2.3-0.3,3.4-0.8c1-0.6,1.9-1.3,2.5-2.4 c0.6-1,0.9-2.2,0.9-3.4c0-1.4-0.3-2.6-0.9-3.5c-0.6-0.9-1.4-1.6-2.4-2.1c-1-0.4-2.1-0.7-3.2-0.7c-0.3,0-0.7,0-1.2,0.1 c-0.5,0.1-0.8,0.1-0.9,0.1c-0.3,0-0.6-0.1-0.7-0.3c-0.2-0.2-0.3-0.5-0.3-0.8s0.1-0.6,0.4-0.9l7.3-8.1h-10.6c-0.3,0-0.6-0.1-0.8-0.3 c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.5-0.3,0.8-0.3h12.8c0.4,0,0.7,0.1,0.9,0.4c0.2,0.2,0.3,0.5,0.3,0.8 s-0.1,0.6-0.4,0.8l-7,7.8h0.2C113.7,15.4,115.1,15.7,116.3,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137,16.4c1.2,0.7,2.2,1.6,3,2.9c0.7,1.3,1.1,2.8,1.1,4.5s-0.4,3.3-1.2,4.6c-0.8,1.3-1.9,2.4-3.4,3.1 c-1.4,0.7-3,1.1-4.7,1.1c-1.1,0-2.1-0.2-3.2-0.5c-1-0.4-1.9-0.9-2.6-1.6c-0.4-0.3-0.5-0.6-0.5-0.9c0-0.3,0.1-0.6,0.3-0.9 c0.2-0.3,0.5-0.4,0.8-0.4c0.3,0,0.6,0.1,0.9,0.4c1.1,1.1,2.5,1.7,4.4,1.7c1.2,0,2.3-0.3,3.4-0.8c1-0.6,1.9-1.3,2.5-2.4 c0.6-1,0.9-2.2,0.9-3.4c0-1.4-0.3-2.6-0.9-3.5c-0.6-0.9-1.4-1.6-2.4-2.1c-1-0.4-2.1-0.7-3.2-0.7c-0.3,0-0.7,0-1.2,0.1 c-0.5,0.1-0.8,0.1-0.9,0.1c-0.3,0-0.6-0.1-0.7-0.3c-0.2-0.2-0.3-0.5-0.3-0.8s0.1-0.6,0.4-0.9l7.3-8.1h-10.6c-0.3,0-0.6-0.1-0.8-0.3 c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.5-0.3,0.8-0.3H139c0.4,0,0.7,0.1,0.9,0.4c0.2,0.2,0.3,0.5,0.3,0.8 s-0.1,0.6-0.4,0.8l-7,7.8h0.2C134.5,15.4,135.8,15.7,137,16.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M-955-737.4h483.6c11,0,20,9,20,20v444.8c0,11-9,20-20,20H-955c-11,0-20-9-20-20v-444.8 C-975-728.5-966-737.4-955-737.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085209601505527782800000000358333904688908469_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    transform: "translate(-975 -590)",
    style: {
      clipPath: "url(#SVGID_00000085209601505527782800000000358333904688908469_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    transform: "translate(960.547 749.196)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line",
    className: "st3",
    d: "M65,2.1v177.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line-2",
    className: "st3",
    d: "M124.2-10.4v189.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Line-3",
    className: "st3",
    d: "M183.4-2.4v181.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Line-4",
    className: "st3",
    d: "M242.6-5.7v185.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Line-5",
    className: "st3",
    d: "M301.8-18.5v198"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Line-6",
    className: "st3",
    d: "M361.1-71.5v251"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Line-7",
    className: "st3",
    d: "M420.3-110.6v290.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Line-8",
    className: "st3",
    d: "M479.5-125.4v304.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_value_00000142854408546088209630000014563844367450068890_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.4025,
    y1: 75.3961,
    x2: 121.4025,
    y2: 76.3961,
    gradientTransform: "matrix(534.374 0 0 314.2315 -64601.9727 -23819.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#51F7E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42B3C0",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_value",
    style: {
      opacity: 0.2,
      fill: "url(#Path_value_00000142854408546088209630000014563844367450068890_)",
      enableBackground: "new"
    },
    d: " M5.1,43.8c0,0,38.4-52.6,117-52.6c31.8,0,81,6.4,145.2,0c83.9-8.4,61-54.9,145.1-99.9c48.4-25.8,127.2-17.4,127.2-17.4v312.9 H5.1V43.8z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st5",
    d: "M0,46.5c0,0,43.5-55.2,122-55.2c31.8,0,70.4,6.4,134.6,0c83.9-8.4,77.2-54.8,161.3-99.7 c48.4-25.9,121.5-17.6,121.5-17.6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 14.45, -159.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Point-2",
    transform: "translate(460.07 176.26)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 5,
    cy: -142.4,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 5,
    cy: -142.4,
    r: 7.5
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    className: "st7",
    d: "M13.1-147.4h518.4c4.4,0,8,3.6,8,8v318.3c0,4.4-3.6,8-8,8H13.1c-4.4,0-8-3.6-8-8v-318.3 C5.1-143.8,8.6-147.4,13.1-147.4z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M50.3,43.1c0.1,0.1,0.1,0.2,0.1,0.3v9c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1 s-0.1-0.2-0.1-0.3v-7.7l-3.3,5c-0.1,0.1-0.2,0.2-0.3,0.2h0c-0.1,0-0.2-0.1-0.3-0.2l-3.3-5v7.7c0,0.1,0,0.2-0.1,0.3 c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3v-9c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1 c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.2,0.1l3.7,5.5l3.7-5.5C49.7,43,49.8,43,50,43C50.1,43,50.2,43,50.3,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M59.6,43.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-2.9v8.6 c0,0.1,0,0.2-0.1,0.3s-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3v-8.6h-2.9c-0.1,0-0.2,0-0.3-0.1 c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h6.7C59.4,43,59.5,43,59.6,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M72.7,44.1c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.1,0-0.2-0.1c-0.7-0.5-1.6-0.7-2.5-0.7 c-0.8,0-1.4,0.2-2.1,0.5c-0.6,0.4-1.1,0.9-1.4,1.5c-0.3,0.6-0.5,1.4-0.5,2.2c0,0.8,0.2,1.6,0.5,2.2c0.4,0.6,0.8,1.1,1.4,1.5 s1.3,0.5,2,0.5c0.9,0,1.7-0.2,2.4-0.7c0.1,0,0.2-0.1,0.2-0.1c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1-0.1,0.3-0.2,0.3 c-0.4,0.2-0.8,0.4-1.3,0.6c-0.5,0.2-1.1,0.2-1.6,0.2c-0.9,0-1.7-0.2-2.5-0.6s-1.3-1-1.8-1.8c-0.4-0.8-0.7-1.6-0.7-2.6 c0-0.9,0.2-1.8,0.7-2.6c0.4-0.8,1-1.4,1.8-1.8c0.7-0.4,1.6-0.7,2.5-0.7c0.5,0,1,0.1,1.5,0.2c0.5,0.1,0.9,0.4,1.4,0.6 C72.6,43.8,72.7,43.9,72.7,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M82.6,50.5c-0.4,0.8-1,1.4-1.7,1.8c-0.7,0.4-1.5,0.7-2.4,0.7s-1.7-0.2-2.4-0.7c-0.7-0.4-1.3-1-1.7-1.8 c-0.4-0.8-0.6-1.6-0.6-2.6c0-1,0.2-1.8,0.6-2.6s1-1.4,1.7-1.8s1.5-0.6,2.4-0.6s1.7,0.2,2.4,0.6c0.7,0.4,1.3,1,1.7,1.8 c0.4,0.8,0.6,1.6,0.6,2.6C83.2,48.8,83,49.7,82.6,50.5z M81.8,45.7c-0.3-0.6-0.8-1.1-1.3-1.5c-0.6-0.4-1.2-0.5-2-0.5 s-1.4,0.2-2,0.5c-0.6,0.4-1,0.9-1.3,1.5c-0.3,0.6-0.5,1.4-0.5,2.2c0,0.8,0.2,1.5,0.5,2.2c0.3,0.6,0.8,1.1,1.3,1.5 c0.6,0.4,1.2,0.5,2,0.5s1.4-0.2,2-0.5c0.6-0.4,1-0.9,1.3-1.5c0.3-0.6,0.5-1.4,0.5-2.2C82.3,47.1,82.1,46.4,81.8,45.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M91,52.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-5.2c-0.1,0-0.2,0-0.3-0.1 c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.3l3.2-3.6c0.5-0.6,0.9-1.1,1.2-1.5s0.4-0.9,0.4-1.3c0-0.6-0.2-1.1-0.6-1.5 c-0.4-0.4-0.9-0.5-1.6-0.5c-0.5,0-0.9,0.1-1.2,0.3c-0.4,0.2-0.6,0.6-0.8,1c-0.1,0.2-0.2,0.3-0.4,0.3c-0.1,0-0.2,0-0.3-0.1 C85,45,84.9,45,84.9,44.9c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.2c0.2-0.5,0.6-0.9,1.1-1.2c0.5-0.3,1-0.4,1.6-0.4 c0.9,0,1.7,0.3,2.2,0.8s0.8,1.2,0.8,2c0,0.5-0.1,1-0.4,1.6c-0.3,0.5-0.7,1.2-1.4,1.9L86.5,52h4.3C90.9,52,91,52,91,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M98.8,49.1c-0.1,0.1-0.2,0.1-0.3,0.1h-5.3c0,0.6,0.1,1.1,0.3,1.5c0.2,0.4,0.6,0.8,1,1c0.4,0.3,0.9,0.4,1.5,0.4 c0.4,0,0.8-0.1,1.2-0.3c0.4-0.2,0.6-0.4,0.9-0.7c0.1-0.1,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3 c0,0.1,0,0.2-0.1,0.3c-0.3,0.4-0.7,0.7-1.1,0.9c-0.5,0.2-0.9,0.3-1.4,0.3c-0.7,0-1.4-0.2-1.9-0.5c-0.6-0.3-1-0.7-1.3-1.3 c-0.3-0.6-0.5-1.2-0.5-1.9c0-0.8,0.2-1.4,0.5-2s0.7-1,1.2-1.3c0.5-0.3,1-0.5,1.6-0.5c0.6,0,1.1,0.1,1.6,0.4 c0.5,0.3,0.9,0.6,1.2,1.1c0.3,0.5,0.5,1.1,0.5,1.8C98.9,48.9,98.9,49,98.8,49.1z M94.2,46.8c-0.5,0.4-0.8,0.9-0.9,1.6h4.8v-0.1 c0-0.4-0.2-0.8-0.4-1.1c-0.2-0.3-0.5-0.6-0.9-0.7c-0.4-0.2-0.7-0.2-1.1-0.2C95.1,46.3,94.6,46.5,94.2,46.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8_00000090990401630722561760000012974089963488805540_",
    transform: "translate(1.964)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Line_00000036253630264874684360000013755390565130765226_",
    className: "st3",
    d: "M56.8,151v177.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Line-2_00000016755987851970310860000003009695385813663889_",
    className: "st3",
    d: "M114.8,138.6v189.9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Line-3_00000134937846840922931660000014110907321106189208_",
    className: "st3",
    d: "M172.8,146.6v181.9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Line-4_00000154417322050325219460000006375119047593793695_",
    className: "st3",
    d: "M230.8,143.3v185.2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Line-5_00000098900919011929860400000017992686311164768177_",
    className: "st3",
    d: "M288.9,130.5v198"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Line-6_00000069384856876134128440000017995983094736399241_",
    className: "st3",
    d: "M346.9,77.5v251"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Line-7_00000174574616327022544650000015949619454073053870_",
    className: "st3",
    d: "M404.9,38.3v290.2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Line-8_00000071532768907931423740000011253890722051019424_",
    className: "st3",
    d: "M462.9,23.6v304.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_value_00000162320765232254854310000006165988207477781656_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.5952,
    y1: 493.2759,
    x2: 44.5952,
    y2: 492.2759,
    gradientTransform: "matrix(534.374 0 0 -314.2315 -23570.6387 155024.4531)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#51F7E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42B3C0",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_value_00000096024412339699285310000010598774790563596456_",
    style: {
      opacity: 0.2,
      fill: "url(#Path_value_00000162320765232254854310000006165988207477781656_)",
      enableBackground: "new"
    },
    d: " M-1.9,192.8c0,0,37.7-52.6,114.6-52.6c31.1,0,79.4,6.4,142.2,0c82.2-8.4,59.7-54.9,142.1-99.9c47.4-25.8,124.6-17.4,124.6-17.4 v312.9H-1.9V192.8z"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_00000170236917177310728050000004449386160873953420_",
    className: "st5",
    d: "M-6.9,195.4c0,0,42.6-55.2,119.6-55.2 c31.1,0,69,6.4,131.9,0c82.2-8.4,75.6-54.8,158-99.7c47.4-25.9,119-17.6,119-17.6"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.96, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Point-2_00000131362559517149420030000015758790446510241959_",
    transform: "translate(476.48 17.06)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: -11.6,
    cy: 6.5,
    rx: 4.9,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: -11.6,
    cy: 6.5,
    rx: 7.3,
    ry: 7.5
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Mask_00000016758015697750844710000017967854745469090489_",
    className: "st7",
    d: "M5.9,1.5h507.9c4.3,0,7.8,3.6,7.8,8v318.3 c0,4.4-3.5,8-7.8,8H5.9c-4.3,0-7.8-3.6-7.8-8V9.5C-1.9,5.1,1.6,1.5,5.9,1.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonChart);
export default __webpack_public_path__ + "static/media/carbon-chart.7a6ee0128c340864a5b73d41be158c0d.svg";
export { ForwardRef as ReactComponent };